import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { useTranslate } from "../Translate/TranslateContext";

export default function Footer() {
  const { translate } = useTranslate();

  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        py: 1.5,
        textAlign: "center",
        color: "var(--color-text-inverse)",
        fontSize: "0.85rem",
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1.2,
          flexWrap: "wrap",
          justifyContent: "center",
          opacity: 0.9,
        }}
      >
        <Link
          to="/terms"
          style={{
            textDecoration: "none",
            color: "var(--color-text-inverse)",
            opacity: 0.85,
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontSize: "0.85rem",     color: "var(--color-text-inverse)", "&:hover": { opacity: 1 } }}
          >
            {translate("terms_and_conditions")}
          </Typography>
        </Link>

        <Typography variant="body2" sx={{ fontSize: "0.85rem" ,     color: "var(--color-text-inverse)"}}>
          {"\u00A9 2026 TensoAI"}
        </Typography>

        <a
          href="https://www.linkedin.com/company/tensoai/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "inline-flex", alignItems: "center" }}
        >
          <Box
            component="img"
            src="/linkedin.png"
            alt="LinkedIn"
            sx={{
              width: 22,
              height: 22,
              objectFit: "contain",
              opacity: 0.8,
              transition: "opacity 0.2s",
              "&:hover": { opacity: 1 },
            }}
          />
        </a>

        <ReactCountryFlag
          countryCode="CA"
          svg
          style={{ width: 22, height: 22, opacity: 0.85 }}
          title="Canada"
        />
      </Box>
    </Box>
  );
}
